import React from "react";

/* The TREVEX mark, oversized and barely-there behind the rail's nav. */
export const SidebarWatermark = () => (
  <svg
    viewBox="0 0 49 52"
    fill="#fff"
    aria-hidden="true"
    /* Inside the rail rather than hanging off its left edge: at -40px the
       mark was sliced down its side and read as broken artwork. Centred and
       sized to the rail, it stays a whole shape. */
    className="pointer-events-none absolute bottom-[80px] left-1/2 w-[200px] -translate-x-1/2 opacity-[.05]"
  >
    <path d="M28.97 35.30H24.27V51.99L48.22 28.01C40.30 27.03 33.14 26.60 26.81 26.52L28.97 35.29Z" />
    <path d="M0.31 23.99C5.08 24.85 12.37 25.80 21.88 25.96L21.99 25.49C20.55 24.69 19.58 23.15 19.58 21.39C19.58 18.79 21.68 16.68 24.27 16.68V0" />
    <path d="M24.28 51.99V35.31H19.58L21.73 26.56C12.59 26.72 5.51 27.62 0.77 28.46L16.18 34.12L24.28 52.00Z" />
    <path d="M28.97 21.39C28.97 23.16 28.00 24.70 26.55 25.50L26.67 25.99C33.16 25.92 40.52 25.48 48.68 24.44L32.37 17.88L24.27 0V16.69C26.86 16.69 28.97 18.80 28.97 21.39Z" />
  </svg>
);

export default SidebarWatermark;
